import { createFileRoute } from '@tanstack/react-router';
import Sheet from 'src/pages/Organization/Event/Sheet';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/sheets',
)({
  component: Sheet,
});
